<template>
  <div class="d-flex justify-space-between detail-apport-header px-0">
    <BaseDataV2
      value="N° Bon"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
   
    <BaseDataV2
      value="Poids net"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
   
    <BaseDataV2
      value="Poids aux normes"
      custom-class="texte texte-gris-fonce"
    />
       
    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.poidsSpecifiqueEnKgParHectolitre)"
      value="PS"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
   
    <BaseDataV2
      value="Humidité"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
   
    <BaseDataV2
      value="Impuretés"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
    
    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.proteineTaux)"
      value="Protéines"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
   
    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.tempsChuteHacbergEnSeconde)"
      value="Hagberg"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
       
    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.echaudeBriseTaux)"
      value="Echaudé, brisé"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
       
    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.germeMitadineFusarieTaux)"
      value="Germé, mitadiné, fusarié"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
       
    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.impureteGrainTaux)"
      cols="6"
      value="Impureté, mitadiné, germé"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
      
    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.mitadineTaux)"
      value="Mitadiné"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
      
    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.zelenyIndiceEnMillilitre)"
      value="Zeleny"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
       
    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.grainBrucheTaux)"
      value="Grains bruchés"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
      
    <BaseDataV2
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.grainCasseTaux)"
      value="Grains cassés"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
       
    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.grainGermeTaux) && apports[0].caracteristiques.grainGermeTaux != null) || isapportsContainsGrainGermeTaux"
      value="Grains germés"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
       
    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.flairAnormal) && apports[0].caracteristiques.flairAnormal === true) || isapportsContainsFlairAnormal"
      value="Présence flair anormal"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
    
    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.insectePresent) && apports[0].caracteristiques.insectePresent === true) || isapportsContainsInsectePresent"
      value="Présence insecte"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
    
    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.matiereGrasseTaux) && apports[0].caracteristiques.matiereGrasseTaux != null) || isapportsContainsMatiereGrasseTaux"
      value="Matières grasses"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
       
    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.omega3Taux) && apports[0].caracteristiques.omega3Taux != null) || isapportsContainsOmega3Taux"
      value="Oméga 3"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
    
    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.daturaPresent) && apports[0].caracteristiques.daturaPresent === true) || isapportsContainsDaturaPresent"
      value="Présence datura"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
       
    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.ergotPresent) && apports[0].caracteristiques.ergotPresent === true) || isapportsContainsErgotPresent"
      value="Présence ergot"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
       
    <BaseDataV2
      v-if="(graineRs3.caracteristiquesSecondaires.includes(caracteristiques.calibrageTaux) && apports[0].caracteristiques.calibrageTaux != null) || isapportsContainsCalibrageTaux"
      value="Calibrage"      
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
      
    <BaseDataV2
      value="Silo"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />

    <BaseDataV2
      value="Contrat"
      class="mb-2 mb-md-0"
      custom-class="texte texte-gris-fonce"
    />
  </div>
</template>

<script>
import caracteristiques from '@/model/caracteristiquesGraines'
import BaseDataV2 from '@/components/common/base-data-v2.vue'

export default {
  name: 'DetailApportHeader',
  components: { BaseDataV2 },
  props: {
    apports: {
      type: Array,
      default: null
    },
    graineRs3: {
      type: Object,
      required: true
    }
  },

  data () {
    return { caracteristiques }
  },

  computed: {
    isapportsContainsGrainGermeTaux () {            
      return this.apports.findIndex(apport => apport.caracteristiques.grainGermeTaux && apport.caracteristiques.grainGermeTaux != null ) !== -1
    },
    isapportsContainsFlairAnormal () {      
      return this.apports.findIndex(apport => apport.caracteristiques.flairAnormal && apport.caracteristiques.flairAnormal === true) !== -1
    },
    isapportsContainsInsectePresent () {      
      return this.apports.findIndex(apport => apport.caracteristiques.insectePresent && apport.caracteristiques.insectePresent === true) !== -1
    },
    isapportsContainsMatiereGrasseTaux () {      
      return this.apports.findIndex(apport => apport.caracteristiques.matiereGrasseTaux && apport.caracteristiques.matiereGrasseTaux != null) !== -1
    },
    isapportsContainsOmega3Taux () {      
      return this.apports.findIndex(apport => apport.caracteristiques.omega3Taux && apport.caracteristiques.omega3Taux != null) !== -1
    },
    isapportsContainsDaturaPresent () {      
      return this.apports.findIndex(apport => apport.caracteristiques.daturaPresent && apport.caracteristiques.daturaPresent === true) !== -1
    },
    isapportsContainsErgotPresent () {      
     return this.apports.findIndex(apport => apport.caracteristiques.ergotPresent && apport.caracteristiques.ergotPresent === true) !== -1
    },
    isapportsContainsCalibrageTaux () {
      return this.apports.findIndex(apport => apport.caracteristiques.calibrageTaux && apport.caracteristiques.calibrageTaux != null) !== -1
    }
  }
}
</script>

<style  lang="scss" scoped>
.detail-apport-header {
  background-color:#F1F2F5;  
  border: 1px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.w-140 {
  width: 140px;
}
</style>
